import { Order } from "../../../entities/orders-pickup-delivery/models/types";
import { http } from "../../../shared/api/http";

/** Ответ API: данные стола и список оплаченных активных заказов */
export interface TableActiveOrdersResponse {
  tableId: string;
  tableNumber: string;
  orders: Order[];
  tableStatus: string;
}

export async function getTableOrders(id: string): Promise<TableActiveOrdersResponse> {
  const res = await http.get<TableActiveOrdersResponse>(`/waiter/tables/${id}/order`);
  return res.data;
}